module.exports = "<igo-feature-details\r\n  [feature]=\"featureService.focusedFeature$ | async\">\r\n\r\n</igo-feature-details>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/lib/tool/tools/feature-detail-tool/feature-detail-tool.component.html
// module id = 1174
// module chunks = 0